/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_AdsInputs */

const en_admin_settings_tabs_ads = /** @type {(inputs: Admin_Settings_Tabs_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ads`)
};

const zh_admin_settings_tabs_ads = /** @type {(inputs: Admin_Settings_Tabs_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`广告`)
};

/**
* | output |
* | --- |
* | "Ads" |
*
* @param {Admin_Settings_Tabs_AdsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_ads = /** @type {((inputs?: Admin_Settings_Tabs_AdsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_AdsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_ads(inputs)
	return zh_admin_settings_tabs_ads(inputs)
});
export { admin_settings_tabs_ads as "admin.settings.tabs.ads" }